import { AfterViewInit, Component, Input, ChangeDetectorRef, inject, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ShowOnDirtyErrorStateMatcher } from '@angular/material/core';

import { Question } from '@empathy/survey/base';

@Component({
  selector: 'empathy-input-question-view',
  templateUrl: 'input-question-view.component.html',
  styleUrls: ['./input-question-view.component.scss', './_input-question-view-theme.component.scss']
})
export class InputQuestionViewComponent implements AfterViewInit {
  @Input() question: Question;
  @Input() questionCtrl: FormControl;

  loading$ = signal(false);

  immediateErrorMatcher = new ShowOnDirtyErrorStateMatcher();

  private cdr = inject(ChangeDetectorRef);

  ngAfterViewInit(): void {
    this.questionCtrl.statusChanges.subscribe((status) => {
      // Ensure view reflects updated state
      this.cdr.markForCheck();

      if (status === 'PENDING' && !this.loading$()) {
        this.loading$.set(true);
      } else if (status !== 'PENDING') {
        this.loading$.set(false);
      }
    });
  }

  onInput(): void {
    if (!this.questionCtrl.touched) {
      this.questionCtrl.markAsTouched();
    }
  }
}
